import CarbonSync from './CarbonSync (1)';

function App() {
  return <CarbonSync />;
}

export default App;
